import { combineReducers } from "redux";

import checkoutReducer from "./slices/checkout";
import serverContextReducer from "./slices/serverContext";
import plansReducer from "./slices/plans";
import recommendedPlanReducer from "./slices/recommendedPlan";
import surveyAnswersReducer from "./slices/surveyAnswers";
import trialReducer from "./slices/trial";
import surveyNameSpaceReducer from "./slices/surveyNameSpace";
import languageReducer from "./slices/language";
import countryCodeReducer from "./slices/countryCode";
import userDataReducer from "./slices/userData";
import koreanProgramReducer from "./slices/koreanProgram";

const combinedSlices = combineReducers({
  serverContext: serverContextReducer,
  checkout: checkoutReducer,
  plans: plansReducer,
  recommendedPlan: recommendedPlanReducer,
  surveyAnswers: surveyAnswersReducer,
  trial: trialReducer,
  userData: userDataReducer,
  surveyNameSpace: surveyNameSpaceReducer,
  language: languageReducer,
  countryCode: countryCodeReducer,
  koreanProgram: koreanProgramReducer,
});

export default combinedSlices;
